<template>
    <van-form ref="form" class="lg:px-24 px-0 pt-32" validate-first validate-trigger="onSubmit" v-if="formData">
        <van-divider>课程基本信息</van-divider>
        <div class="flex flex-wrap justify-around">
            <div class="md:w-96 w-full">
                <van-cell-group class="md:mt-10 mt-0 shadow-md" inset>
                    <van-field v-model="formData.className" maxlength="50" label="课程名称" placeholder="请输入"
                        :rules="[{ required: true, message: '请填写课程名称' }]" />

                    <van-field v-model="formData.langs.zh.classInfo" rows="6" autosize label="课程描述" type="textarea"
                        maxlength="300" placeholder="请输入简短的课程描述" show-word-limit clearable />

                    <van-field v-model="formData.classAddress" label="课程地点" placeholder="请填写具体物理地点"
                        :rules="[{ required: true, message: '请填写课程的具体地点' }]" />
                </van-cell-group>
                <van-cell-group class="md:mt-10 mt-0 shadow-md" inset v-if="formData.langs.en">
                    <van-field v-model="formData.langs.en.className" maxlength="100" label="课程名称"
                        placeholder="Class Name" />
                    <van-field v-model="formData.langs.en.classInfo" maxlength="300" label="课程描述"
                        placeholder="Class Info" />
                </van-cell-group>
                <div class="flex flex-row justify-center mt-6" v-if="formData.langs.en">
                    <van-button type="warning" @click="translateEnglish()">自动翻译测试</van-button>
                </div>
                <div class="flex flex-row justify-center mt-6" v-if="mode === 'new' || mode === 'edit'">
                    <van-button type="primary" @click="addEnglish()">添加英文翻译</van-button>
                </div>
            </div>
            <div class="md:w-96 w-full md:pt-0 pt-8">
                <van-cell-group title="课程重点信息" class="shadow-md" inset>
                    <van-field v-model="formData.classMetaInfo[index]" v-for="(info, index) in formData.classMetaInfo"
                        :key="index" label="重点信息" placeholder="请输入" maxlength="50"
                        :rules="[{ required: true, message: '请填写课程重点信息' }]">
                        <template #right-icon>
                            <van-icon name="clear" @click="removeMeta(index)" />
                        </template>
                    </van-field>
                </van-cell-group>
                <div class="text-center">
                    <van-button class="mt-4" type="primary" icon="plus" @click="addMeta()"></van-button>
                </div>
            </div>
        </div>

        <van-divider class="pt-14">课程日程时间安排</van-divider>
        <div class="flex flex-wrap justify-around">
            <div class="md:w-96 w-full pb-8">
                <van-cell-group class="mb-8 shadow-md" inset>
                    <van-field v-model="formData.classDates.start.text" readonly clickable is-link label="开始日期"
                        placeholder="请选择" @click="showDatePicker(formData.classDates.start)"
                        :rules="[{ required: true, message: '请选择课程开始日期' }]" />

                    <van-field v-model="formData.classDates.end.text" readonly clickable is-link label="结束日期"
                        placeholder="请选择" @click="showDatePicker(formData.classDates.end)"
                        :rules="[{ required: true, message: '请选择课程结束日期' }]" />

                    <van-field v-model.number="formData.classDates.cost" type="digit" label="Credit" />
                </van-cell-group>
            </div>
            <div class="md:w-96 w-full md:pt-0 pt-8">
                <van-cell-group class="mb-8 shadow-md" v-for="(time, index) in formData.classTimes" :key="index" inset>
                    <van-field v-model="time.text" readonly clickable is-link :label="'第' + (index + 1) + '节'"
                        placeholder="请选择时间" :rules="[{ required: true, message: '请选择课程时间' }]"
                        @click="showTimePicker(time)" />
                    <van-field label="时长(分钟)">
                        <template #input>
                            <van-stepper v-model="time.duration" step="5" integer min="0" max="600"
                                default-value="60" />
                        </template>
                        <template #right-icon>
                            <van-icon name="clear" @click="removeTime(index)" />
                        </template>
                    </van-field>
                    <van-field v-model="time.location" label="上课位置" placeholder="可不填" />
                </van-cell-group>
                <div class="text-center">
                    <van-button type="primary" icon="plus" @click="addTime()"></van-button>
                </div>
            </div>
        </div>

        <van-divider class="pt-14">课程老师</van-divider>
        <div class="pb-12 flex flex-wrap justify-center">
            <teacher-icons :teachers="formData.teachers" :sizeClass="['mx-3', 'mt-4', 'w-24', 'h-24', 'shadow-md']" />
            <van-button v-if="!isTeacher" class="w-24 h-24 mx-3 mt-4" icon="plus" type="primary"
                @click="teacherPicker()" />
        </div>
        <van-divider />
    </van-form>
    <div class="text-center pt-24">
        <van-button class="w-32" type="primary" :loading="submitting" loading-text="提交中..." @click="submit()">
            提交
        </van-button>
    </div>

    <van-popup v-model:show="showDate" position="bottom" round>
        <van-datetime-picker v-model="today" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
            @confirm="pickDate" @cancel="showDate = false" />
    </van-popup>
    <teacher-picker ref="teacherPickerRef" @finish="gotTeachers" />
    <van-popup v-model:show="showTime" position="bottom" round>
        <van-picker title="选择开始时间" :columns="timeOptions" @confirm="pickTime" @cancel="showTime = false" />
    </van-popup>
</template>

<script>
import Env from "@/logics/Envs.js";
import {
    ref,
    computed,
    onMounted
} from "vue";
import {
    useStore
} from "vuex";
import {
    useRouter,
    useRoute
} from "vue-router";
import axios from "axios";
import {
    Button,
    Form,
    Field,
    Picker,
    Popup,
    Divider,
    Icon,
    CellGroup,
    DatetimePicker,
    Toast,
    Stepper,
    Dialog,
    Notify
} from "vant";
import StaticDays from "@/static_values/StaticDays.js";
import UserTypes from "@/static_values/StaticUserTypes.js";
import Helpers from "@/logics/Helpers.js";
import TeacherIcons from "@/components/list/TeacherIcons.vue";
import TeacherPicker from "@/components/dialog/TeacherPicker.vue";
import GetSession from "@/asyncs/GetSession.js";
import TranslateEnglish from "@/asyncs/TranslateEnglish.js";

export default {
    name: "PageCreateClass",
    components: {
        [Button.name]: Button,
        [Form.name]: Form,
        [Field.name]: Field,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
        [Divider.name]: Divider,
        [Icon.name]: Icon,
        [CellGroup.name]: CellGroup,
        [DatetimePicker.name]: DatetimePicker,
        [Toast.name]: Toast,
        [Stepper.name]: Stepper,
        TeacherIcons,
        TeacherPicker
    },
    setup() {
        const store = useStore();
        store.commit("showBack");
        store.commit("showMenu");
        const router = useRouter();
        const route = useRoute();
        const makeDateText = function (dates) {
            dates.text = dates.year + "-" + dates.month + "-" + dates.day;
        };
        const mode = route.params.mode;
        let formData = ref(null);
        onMounted(() => {
            GetSession({
                store,
                router,
                route
            }, async function () {
                if (mode === "edit") {
                    store.commit("setPageTitle", "修改课程");
                    makeDateText(store.state.classDetails.classDates.start);
                    makeDateText(store.state.classDetails.classDates.end);
                    store.state.classDetails.classTimes.forEach(function (classTime) {
                        classTime.text = StaticDays[classTime.day]["zh"] + " " +
                            Helpers.makeClassTimeToText(classTime.timeStart);
                    });
                    formData.value = store.state.classDetails;
                } else if (mode === "new") {
                    store.commit("setPageTitle", "建立新课程");
                    formData.value = {
                        className: "",
                        langs: {
                            zh: {
                                className: "",
                                classInfo: ""
                            }
                        },
                        classMetaInfo: [""],
                        classAddress: store.state.school.address,
                        classDates: {
                            start: {
                                year: 0,
                                month: 0,
                                day: 0,
                                text: ""
                            },
                            end: {
                                year: 0,
                                month: 0,
                                day: 0,
                                text: ""
                            },
                            cost: 0
                        },
                        classTimes: [{
                            day: 1,
                            timeStart: 0,
                            timeEnd: 0,
                            duration: 60
                        }],
                        teachers: [],
                        payPlans: []
                    };
                } else if (mode === "copy") {
                    store.commit("setPageTitle", "复制新课程");
                    store.state.classDetails.className += " (这是复制)";
                    delete store.state.classDetails.classId;
                    makeDateText(store.state.classDetails.classDates.start);
                    makeDateText(store.state.classDetails.classDates.end);
                    store.state.classDetails.classTimes.forEach(function (classTime) {
                        classTime.text = StaticDays[classTime.day]["zh"] + " " +
                            Helpers.makeClassTimeToText(classTime.timeStart);
                    });
                    formData.value = store.state.classDetails;
                }

                if (store.state.user.userType === UserTypes.teacher.value) {
                    formData.value.teachers.splice(0, formData.value.teachers.length);
                    formData.value.teachers.push({
                        id: store.state.user.userId,
                        name: store.state.user.profile.showName,
                        icon: store.state.user.profile.icon,
                        type: 1
                    });
                }
            });
        });
        const addEnglish = function () {
            formData.value.langs.en = {
                className: "",
                classInfo: ""
            };
        };
        const translateEnglish = async function () {
            const waitingToast = Toast.loading({
                forbidClick: true,
                duration: 0
            });
            if (formData.value.className) {
                formData.value.langs.en.className = await TranslateEnglish(formData.value.className);
            }
            if (formData.value.langs.zh.classInfo) {
                formData.value.langs.en.classInfo = await TranslateEnglish(formData.value.langs.zh.classInfo);
            }
            waitingToast.clear();
        };

        //Manage dates options
        let datesToSet = null;
        const showDate = ref(false);
        const pickDate = function (date) {
            datesToSet.year = date.getFullYear();
            datesToSet.month = date.getMonth() + 1;
            datesToSet.day = date.getDate();
            makeDateText(datesToSet);
            datesToSet = null;
            showDate.value = false;
        };
        const showDatePicker = function (dates) {
            datesToSet = dates;
            showDate.value = true;
        };

        //Manage class times
        const addTime = function () {
            formData.value.classTimes.push({
                day: 1,
                timeStart: 0,
                timeEnd: 0,
                duration: 60
            });
        };
        const removeTime = function (index) {
            formData.value.classTimes.splice(index, 1);
        };
        const showTime = ref(false);
        let timeSection = null;
        const showTimePicker = function (time) {
            timeSection = time;
            showTime.value = true;
        };
        const timeOptions = [{
            values: Object.entries(StaticDays).map(a => {
                return {
                    text: a[1]["zh"],
                    value: parseInt(a[0]) //Property name in JS object is string
                }
            })
        },
        {
            values: Array.from(new Array(24).keys())
        },
        {
            values: new Array(12).fill(0).map((a, i) => {
                return i * 5 + a;
            })
        }
        ];
        const pickTime = function (items) {
            timeSection.text = items[0].text + " " + items[1].toString().padStart(2, "0") + ":" + items[2].toString().padStart(2, "0");
            timeSection.day = items[0].value;
            timeSection.timeStart = items[1] * 100 + items[2];
            showTime.value = false;
        };

        const addMeta = function () {
            formData.value.classMetaInfo.push("");
        };
        const removeMeta = function (index) {
            formData.value.classMetaInfo.splice(index, 1);
        };

        const teacherPickerRef = ref(null);
        const teacherPicker = function () {
            teacherPickerRef.value.showPop();
        };
        const gotTeachers = function (teachers) {
            formData.value.teachers.splice(0, formData.value.teachers.length);
            formData.value.teachers.push(...teachers);
        };

        const form = ref(null);
        const submitting = ref(false);
        const submit = function () {
            if (submitting.value) {
                return;
            }
            form.value.validate().then(function () {
                let url = Env.apiPath + "addClass";
                let dialogMessage = "确定建立此新课程吗？";
                let successMessage = "新课程已建立成功";
                if (mode === "edit") {
                    url = Env.apiPath + "updateClass";
                    dialogMessage = "确定更新信息吗？";
                    successMessage = "课程已更新成功";
                }

                Dialog.confirm({
                    title: dialogMessage,
                    confirmButtonColor: "#ee0a24"
                })
                    .then(function () {
                        submitting.value = true;
                        //delete display
                        delete formData.value.classDates.start.text;
                        delete formData.value.classDates.end.text;
                        formData.value.classTimes.forEach(function (item) {
                            let hour = Math.trunc(item.timeStart / 100);
                            let min = item.timeStart % 100 + item.duration;
                            hour = (hour + Math.trunc(min / 60)) % 24;
                            min = min % 60;
                            item.timeEnd = hour * 100 + min;
                            //delete display
                            delete item.text;
                        });
                        delete formData.value.students;
                        delete formData.value.payPlans;

                        let toSend = new FormData();
                        formData.value.langs.zh.className = formData.value.className;
                        toSend.append("classData", JSON.stringify(formData.value));
                        axios.post(url, toSend).then(function (res) {
                            if (res.data.error) {
                                Notify({
                                    type: "danger",
                                    message: "抱歉，提交信息失败：" + res.data.error
                                });
                                submitting.value = false;
                                return;
                            }
                            Notify({
                                type: "success",
                                message: successMessage
                            });
                            if (res.data.classId) {
                                formData.value.classId = res.data.classId;
                            }
                            store.commit("setClassDetails", formData.value);
                            router.push("/viewClassList");
                        }).catch(function (e) {
                            Notify({
                                type: "danger",
                                message: "抱歉，服务器有错误：" + e.toString()
                            });
                            submitting.value = false;
                        });
                    }).catch(function () {
                        console.log("dialog cancel");
                    });
            }).catch(function (e) {
                Toast(e[0].message);
            });
        };

        return {
            formData,
            form,
            addMeta,
            removeMeta,
            minDate: new Date(2000, 0, 1),
            maxDate: new Date(2045, 0, 1),
            today: new Date(),
            showDate,
            pickDate,
            showDatePicker,
            addTime,
            removeTime,
            pickTime,
            showTime,
            showTimePicker,
            timeOptions,
            teacherPickerRef,
            teacherPicker,
            gotTeachers,
            submit,
            submitting,
            isTeacher: computed(() => UserTypes.teacher.value === store.state.user.userType),
            addEnglish,
            mode,
            translateEnglish
        };
    }
}
</script>
